<template>
  <div class="containerdiv" v-if="orderInfo">
    <div class="carousel">
      <van-swipe
        width="100%"
        height="375"
        class="swiper"
        show-indicators
        :duration="400"
        :autoplay="0"
      >
        <template>
          <van-swipe-item class="swiper-item">
            <van-image
              lazy-load
              :src="orderInfo.productPic"
              class="image-wrapper"
            ></van-image>
          </van-swipe-item>
        </template>
      </van-swipe>
    </div>
    <div class="yt-list">
      <div class="yt-list-cell b-b">
        <span class="cell-tit clamp">付款日期</span>
        <span class="cell-tip">{{ orderInfo.createTime }}</span>
      </div>
      <div class="yt-list-cell b-b">
        <span class="cell-tit clamp">产品名称</span>
        <span class="cell-tip">{{ orderInfo.productName }}</span>
      </div>
      <div class="yt-list-cell b-b">
        <span class="cell-tit clamp">产品规格</span>
        <span class="cell-tip">{{ orderInfo.productSpec }}</span>
      </div>
      <div class="yt-list-cell b-b">
        <span class="cell-tit clamp">订单编号</span>
        <span class="cell-tip">{{ orderInfo.orderNo }}</span>
      </div>
       <div class="yt-list-cell b-b">
        <span class="cell-tit clamp">购买会员</span>
        <span class="cell-tip">{{ orderInfo.memberName }}</span>
      </div>
      <div class="yt-list-cell b-b">
        <span class="cell-tit clamp">商品金额</span>
        <span class="cell-tip" style="color: #fa436a"
          >￥{{ orderInfo.price }}</span
        >
      </div>
    </div>
    <!-- 底部操作菜单 -->
    <div class="page-bottom">
      <div class="action-btn-group">
        <div class="no-border buy-now-btn action-buy-two" @click="confirm">
          <div v-if="finish">已核销</div>
          <div v-else>确定核销</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {myMixins} from '@/mixins'
import { mapState } from "vuex";
export default {
  mixins:[myMixins],
  created() {
    let avatar = localStorage.getItem("avatar") || '';

    if (this.existField(this.userInfo.avatar) || this.existField(avatar)) {
    }else{
      this.toWechatAuth();
    }
    let query = this.$route.query;
    this.itemId = query.itemId;
    this.orderId = query.orderId;
    if (this.itemId && this.orderId) {
      this.loadData();
    }
  },
  computed:{
     ...mapState(["userInfo"]),
  },
  data() {
    return {
      orderInfo: null,
      itemId: "",
      orderId: "",
      finish:false
    };
  },
  methods: {
     existField(filed){
      let flag = true;
      if(filed == undefined || filed == null || filed == '' || filed == 'null'){
        flag = false;
      }
      return flag;
    },
    toWechatAuth() {
      this.$router.push({
        path: "/pages/WechatAuth",
        query: {
          redirectUrl: this.$route.fullPath,
        },
      });
    },
    loadData() {
      let url = this.$http.pathMap.orderInfo + this.orderId + "/" + this.itemId;
      this.$http.request(url, "get").then((res) => {
        this.orderInfo = res.data;
      });
    },
    confirm() {
      if(this.finish) {
        return
      }
      let url = this.$http.pathMap.orderOff;
      let params = {
        orderId: this.orderId,
        itemId: this.itemId,
      };
      this.$http.request(url, "post", params).then(res => {
        this.$toast('核销成功！')
        this.finish = true
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.containerdiv {
  padding-bottom: 120px;
  .carousel {
    height: 375px;
    position: relative;

    .swiper {
      height: 100%;
    }

    .image-wrapper {
      width: 100%;
      height: 100%;
    }

    .swiper-item {
      display: flex;
      justify-content: center;
      align-content: center;
      overflow: hidden;
      position: relative;
      .try-div {
        position: absolute;
        bottom: 0;
        left: 30px;
        color: #fff;
        font-size: 12px;
      }
      .try-active {
        position: absolute;
        &::before {
          display: block;
          content: "";
          position: absolute;
          bottom: 0px;
          left: -30px;

          width: 600px;
          height: 70px;
          z-index: 9999;
          //background: pink;
        }
      }

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .yt-list {
    background: #fff;
  }
  .yt-list-cell {
    display: flex;
    align-items: center;
    padding: 5px 15px 5px 20px;
    line-height: 35px;
    position: relative;

    &.cell-hover {
      background: #fafafa;
    }

    &.b-b:after {
      left: 15px;
    }

    .cell-icon {
      height: 16px;
      width: 16px;
      font-size: 11px;
      color: #fff;
      text-align: center;
      line-height: 16px;
      background: #f85e52;
      border-radius: 2px;
      margin-right: 6px;

      &.hb {
        background: #ffaa0e;
      }

      &.lpk {
        background: #3ab54a;
      }
    }

    .cell-more {
      align-self: center;
      font-size: 12px;
      color: $font-color-light;
      margin-left: 4px;
      margin-right: -5px;
    }

    .cell-tit {
      flex: 1;
      font-size: 13px;
      color: $font-color-light;
      margin-right: 5px;
    }

    .cell-tip {
      font-size: 13px;
      color: $font-color-dark;

      &.disabled {
        color: $font-color-light;
      }

      &.active {
        color: $base-color;
      }

      &.red {
        color: $base-color;
      }
    }

    &.desc-cell {
      .cell-tit {
        max-width: 45px;
      }
    }

    .desc {
      flex: 1;
      font-size: $uni-font-size-base;
      color: $font-color-dark;
    }
  }
  .page-bottom {
    position: fixed;
    left: 0px;
    bottom: 0;
    z-index: 95;
    display: flex;
    justify-content: space-around;
    padding-top: 10px;
    width: 100%;
    height: 70px;
    background: #fff;
    border-radius: 8px;

    .p-b-btn {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: $uni-font-size-sm;
      color: $font-color-base;
      width: 48px;
      height: 40px;

      .yticon {
        font-size: 20px;
        line-height: 24px;
        color: $font-color-light;
      }

      &.active,
      &.active .yticon {
        color: var(--theme-font-color);
      }

      .icon-fenxiang2 {
        font-size: 21px;
        transform: translateY(-2upx);
      }

      .icon-shoucang {
        font-size: 23px;
      }
    }

    .action-btn-group {
      display: flex;
      flex: 1;
      overflow: hidden;
      margin-left: 10px;
      margin-right: 10px;
      position: relative;
      justify-content: center;
      .action-buy {
        width: 100px;
        height: 40px;
        background: #496bcb;
        border-radius: 0 100px 100px 0;
        opacity: 1;
        text-align: center;
        line-height: 40px;
        color: #fff;
      }
      .action-buy-two {
        width: 350px;
        height: 40px;
        background: #496bcb;
        opacity: 1;
        text-align: center;
        line-height: 40px;
        color: #fff;
      }
      .action-btn {
        width: 100px;
        height: 40px;
        background: #ffd014;
        border-radius: 100px 0px 0px 100px;
        opacity: 1;
        text-align: center;
        line-height: 40px;
        color: #fff;
      }
      .action-btn::after {
        border: none;
      }
    }
  }
}
</style>
